<template>
    <div class="md-layout text-center login-fix-page">
        <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix">
            <div class="h-full w-full flex flex-col items-center">
                <form @submit.prevent="login" class="w-full mb-4">
                    <login-card header-color="green">
                        <h4 slot="title" class="title font-medium">GAIA - Application mobile</h4>
                        <md-field class="form-group md-invalid" slot="inputs" style="margin-bottom: 28px">
                            <label>Adresse email</label>
                            <md-input v-model="email" type="email"/>
                            <validation-error :errors="apiValidationErrors.email"/>
                        </md-field>
                        <md-field class="form-group md-invalid" slot="inputs">
                            <label>Mot de passe</label>
                            <md-input v-model="password" type="password" autocomplete="off" />
                            <validation-error :errors="apiValidationErrors.password"/>
                        </md-field>
                        <md-button slot="footer" class="md-success" type="submit">
                            <span class="font-medium">Connexion</span>
                        </md-button>
                    </login-card>
                </form>
                <md-button class="md-success 2xl:hidden" href="tel:+33475404750" target="_blank">
                    <span class="text-white font-medium">Tél. 04 75 40 47 50</span>
                </md-button>
	            <div class="block-version mt-3 rounded">
		            <span class="text-white font-medium text-xs">{{ cacheVersion }}</span>
	            </div>
            </div>
        </div>
    </div>
</template>

<script>
import { LoginCard, ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import applicationVersionMixin from "@/mixins/application-version-mixin";

export default {
    name: "ProgressiveWebAppLogin",
    components: {
        LoginCard,
        ValidationError,
    },
    mixins: [formMixin, applicationVersionMixin],
    data() {
        return {
            email: '',
            password: '',
	        cacheVersion: ''
        }
    },
    methods: {
        async login() {
            this.resetApiValidation();
            const user = {
                data: {
                    type: "token",
                    attributes: {
                        email: this.email,
                        password: this.password,
                    },
                },
            };
            try {
                await this.$store.dispatch("pwaAuth/pwaLogin", user)
            } catch (e) {
                this.setApiValidation([this.formatErrorMessage(e.response.data)])
            }
        },
        formatErrorMessage(error) {
            let errorMessage = ''
            switch(error.type) {
                case 'password':
                    errorMessage = {
                        source: { pointer: '/data/attributes/password' },
                        detail: 'Le mot de passe est incorrect'
                    }
                    break
                case 'active':
                    errorMessage = {
                        source: { pointer: '/data/attributes/email' },
                        detail: 'Le compte est inactif'
                    }
                    break
                default:
                    errorMessage = {
                        source: { pointer: '/data/attributes/email' },
                        detail: 'Une erreur est survenue'
                    }
                    break
            }
            return errorMessage
        },
    },
    mounted() {
        document.title = 'Gaia - Application mobile'

	    this.getCacheVersion().then(cacheVersion => {
		    this.cacheVersion = 'Version ' + cacheVersion
	    })
    }
}
</script>

<style scoped lang="scss">
.block-version {
	padding: .25rem 1rem;
	background-color: $gray-color;
}
</style>
